import React,{useState} from "react";
import axios from "../../axios";
import * as url from "../../utils/url";
import Toggle from "react-toggle";
// import { MdOutlineUpdateDisabled } from "react-icons/md";
// import { BiRefresh } from "react-icons/bi";
// TbRefreshOff
import { TbRefreshOff, TbRefresh } from "react-icons/tb";
import Select from "react-select";
import ChartInfoPopover from "./ChartInfoPopover";


export default function LockUnlockChartComponent({
  chart,
  updateChart,
  isChartList,
  user,
  renderIntoAlert,
  alertMessage,
}) {
  const handleLockToggleChange = (e) => {
    // const checked = e.target.checked;
    // console.log('e ---  ', e)
    const checked = e.value;
    // axios
    //   .post(url.lockUnlockChart, {
    //     lockedDate: checked ? new Date() : null,
    //     chartId: chart._id,
    //   })
    //   .then(({ data }) => {
    if (checked) {
      updateChart({ ...chart, lockedDate: new Date() });
    } else {
      updateChart({ ...chart, lockedDate: null });
    }
    // })
    // .catch((err) => {
    //   console.log(err);
    // });
  };

  const options = [
    { value: false, label: "Chart is active" },
    { value: true, label: "Chart is locked" },
  ];

  

  if (isChartList) {
    if (chart.lockedDate) {
      return (
        <div>
          Chart is locked <TbRefreshOff size="14px" /> <ChartInfoPopover chartId={chart._id}/>
        </div>
      );
    } else {
      return (
        <div>
          Chart is active <TbRefresh size="14px" /> <ChartInfoPopover chartId={chart._id}/>
        </div>
      );
    }
  } else {
    return (
      <Select
        onChange={handleLockToggleChange}
        // name="role"
        options={options}
        // optionRenderer={this.renderOfficePaths}
        value={chart.lockedDate ? options[1] : options[0]}
        // placeholder={"Chart is active"}
      />
    );
  }

  // if(user.profile && chart.createdBy && chart.createdBy._id == user.profile._id){
  //   if(renderIntoAlert){
  //     return <Alert color="warning">
  //     Unlocked <BiRefresh size={"16px"} className="mr-2"/>
  //       <span className="mt-2 pb-2 mr-2">
  //         <Toggle
  //           checked={chart.lockedDate ? true : false}
  //           icons={false}
  //           onChange={handleLockToggleChange}
  //         />{" "}
  //       </span>
  //      Locked  <MdOutlineUpdateDisabled size={"16px"}  /> <span className="ml-2">{chart.lockedDate ? alertMessage:""}</span>
  //     </Alert>
  //   }else{
  //     return (
  //       <span className="mt-2 pb-2">
  //         <Toggle
  //           checked={chart.lockedDate ? true : false}
  //           icons={false}

  //           onChange={handleLockToggleChange}
  //         />{" "}
  //       <label>{chart.lockedDate ? "Disable Update" : "Enable Update"}</label>
  //       </span>
  //     );
  //   }

  // }else{
  //    return <span></span>
  // }
}
